import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { take, map } from "rxjs/operators";
import { lmwAuthLazyLoadedState } from '../../common/routing/route-locales/app-routes';
import { signInLazyLoaded } from './route-locales/sign-in-routes';
import { SignInService } from "../services/sign-in.service";

@Injectable({
  providedIn: 'root'
})

export class SignInRouteDataGuard  {

  constructor(private signInService: SignInService, private router: Router) {
  }

  canActivate(): Observable<boolean> {
    return this.signInService.selectSignInStore().pipe(take(1),
      map((signInCredentials) => {
        if (signInCredentials.email || signInCredentials.phoneNumber) {
          return true;
        } else {
          this.router.navigate([`${lmwAuthLazyLoadedState.path}/${signInLazyLoaded.path}`])
          return false;
        }
      })
    )
  }
}
